import { combineReducers } from "redux";
import auth from "./auth/reducer";
import investigation from "./investigation/reducer";
import validation from "./validation/reducer";

const appReducer = combineReducers({
  auth: auth,
  investigation: investigation,
  validation: validation,

});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
